import * as ActionTypes from './actionTypes';
import { QueryTypes, LocationTypes } from './types';

const initialState = {
  query: {
     date_from: '',
     date_to: '',
     location: {id: "", label:"", type: LocationTypes.GEO_LOCATION},
     type: QueryTypes.COURSE,
     text: '',
  },
  categories: [],
  response_type: undefined,
  organizers: [],
  courses: [],
  golf_courses: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_SEARCH_PARAMS:
      return {
        ...state,
        query: action.query
      };
    case ActionTypes.FETCH_SEARCH_SUCCESS:
      const {
        rawResponse: {
          organizers: {
            results: organizerResults = []
          } = {},
          courses:  {
            results: courseResults = []
          } = {},
          golf_courses:  {
            results: golfCourseResults = []
          } = {},
          services: {
            response_type = '',
          } = {},
        } = {}
      } = action.response

      return {
        ...state,
        organizers: organizerResults,
        courses: courseResults,
        golf_courses: golfCourseResults,
        response_type,
      };
    case ActionTypes.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.response.result
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/search/reducer.js